export const MAX_FAQ_CATEGORIES = 20
export const MAX_FAQ_ARTICLES_PER_CATEGORY = 20

export const FAQ_CATEGORY_VISIBILITY_OPTIONS = [
  { label: 'Visible', value: 'VISIBLE' },
  { label: 'Hidden', value: 'HIDDEN' },
] as const

export const FAQ_ARTICLE_STATUS_OPTIONS = [
  { label: 'Published', value: 'PUBLISHED' },
  { label: 'Unpublished', value: 'UNPUBLISHED' },
] as const
